import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { posts } from '../data/posts';
export function Blog() {
  // Show only first 3 posts on home page
  const featuredPosts = posts.slice(0, 3);
  return <section id="blog" className="px-6 py-24 bg-white" data-id="element-9">
      <div className="max-w-7xl mx-auto" data-id="element-10">
        <motion.div className="mb-16 md:mb-24 max-w-3xl" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-11">
          <h2 className="text-4xl md:text-5xl font-serif mb-6 text-[#4A3B47]" data-id="element-12">
            Stories & Insights
          </h2>
          <p className="text-lg text-[#4A3B47]/70 leading-relaxed" data-id="element-13">
            Exploring the intersection of brand strategy, community building,
            and user experience design.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12" data-id="element-14">
          {featuredPosts.map((post, index) => <motion.article key={post.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="group cursor-pointer flex flex-col h-full" data-id="element-15">
              <Link to={`/blog/${post.id}`} className="block" data-id="element-16">
                <div className="relative overflow-hidden rounded-2xl mb-6 aspect-[4/3]" data-id="element-17">
                  <div className="absolute inset-0 bg-[#4A3B47]/10 group-hover:bg-transparent transition-colors duration-500 z-10" data-id="element-18" />
                  <img src={post.image} alt={post.title} className={`w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700 ease-out ${post.imagePosition || ''}`} data-id="element-19" />
                  <div className="absolute top-4 left-4 z-20 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-medium text-[#4A3B47] uppercase tracking-wider" data-id="element-20">
                    {post.category}
                  </div>
                </div>
              </Link>

              <div className="flex flex-col flex-grow" data-id="element-21">
                <div className="text-sm text-[#A88B9D] mb-3 font-medium" data-id="element-22">
                  {post.date}
                </div>
                <h3 className="text-2xl font-serif text-[#4A3B47] mb-3 group-hover:text-[#A88B9D] transition-colors duration-300" data-id="element-23">
                  <Link to={`/blog/${post.id}`} data-id="element-24">{post.title}</Link>
                </h3>
                <p className="text-[#4A3B47]/70 leading-relaxed mb-6 flex-grow" data-id="element-25">
                  {post.excerpt}
                </p>

                <Link to={`/blog/${post.id}`} className="flex items-center text-[#4A3B47] font-medium group-hover:text-[#A88B9D] transition-colors duration-300 mt-auto" data-id="element-26">
                  Read Article{' '}
                  <ArrowRight className="w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform duration-300" data-id="element-27" />
                </Link>
              </div>
            </motion.article>)}
        </div>

        <div className="mt-16 text-center" data-id="element-28">
          <Link to="/blog" className="inline-flex items-center justify-center px-8 py-4 border border-[#4A3B47]/20 rounded-full text-[#4A3B47] font-medium hover:bg-[#4A3B47] hover:text-white transition-all duration-300" data-id="element-29">
            View All Articles
          </Link>
        </div>
      </div>
    </section>;
}